module.exports = __webpack_public_path__ + "static/img/fz_rb_tb.04ee292.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_rb_tb.png
// module id = P5F9
// module chunks = 0